<template>
  <div class="progress-wave">
    <canvas :id="`progress-wave-${unique}`" :width="width" :height="height" />
  </div>
</template>

<script>
import down_img from "@/assets/images/download.png";

export default {
  name: "ProgressWave",
  data() {
    return {
      ele: null,
      progress: 0,
      waveWidth: 0.05, // 波浪宽度，越小越宽
      waveHeight: 6, // 波浪高度，越大越高
      speed: 0.09, // 速度，越大速度越快
      xOffset: 0, // 初始波浪x偏移量
      sX: 0,
      nowRange: 40,
      down_img,
      width: 60,
      height: 60
    };
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    unique: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      default: "#ffffff"
    },
    circleText: {
      type: String,
      default: ""
    }
  },
  methods: {
    draw: function() {
      let canvas = this.ele;
      let dpr = 1;
      //   let rad = (Math.PI * 2) / 100;
      this.setWidth();

      canvas.width = this.width * dpr;
      canvas.height = this.height * dpr;

      let ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.scale(dpr, dpr);

      if (this.progress <= this.value) {
        this.progress += 1;
      }
      if (this.progress > this.value) {
        this.progress -= 1;
      }

      this.drawCircle(ctx);
      // 画波浪
      this.drawSin(ctx, this.xOffset + Math.PI * 0.7, "rgba(3,213,160,.15)");
      //   this.drawSin(ctx, this.xOffset, "#01B377");
      this.drawText(ctx);

      this.xOffset += this.speed;

      requestAnimationFrame(this.draw);
    },

    drawCircle: function(ctx) {
      const lineWidth = 2;
      const x = this.width / 2,
        y = this.width / 2,
        r = this.width / 2 - lineWidth;
      ctx.save();
      ctx.beginPath();
      ctx.lineWidth = lineWidth;
      ctx.strokeStyle = "#323642";
      ctx.arc(x, y, r + 1, 0, 2 * Math.PI);
      ctx.stroke();
      // 切片，切小圆与外环中间有个间隔
      ctx.beginPath();
      ctx.arc(x, y, r - 3, 0, 2 * Math.PI);
      ctx.fillStyle = "rgba(3,213,160,.06)";
      ctx.fill();
      ctx.clip();
    },

    drawSin: function(ctx, xOffset, color) {
      ctx.save();
      let points = [];
      ctx.beginPath();

      for (let x = this.sX; x < this.sX + this.width; x += 20 / this.width) {
        let y = Math.sin((-this.sX - x) * this.waveWidth + xOffset) * 0.8 + 0.1;
        let dY = this.height * (1 - this.progress / 100);
        points.push([x, dY + y * this.waveHeight]);
        ctx.lineTo(x, dY + y * this.waveHeight);
      }

      //封闭路径
      ctx.lineTo(this.width, this.height);
      ctx.lineTo(this.sX, this.height);
      ctx.lineTo(points[0][0], points[0][1]);
      ctx.fillStyle = color;
      ctx.fill();

      ctx.restore();
    },

    drawText: function(ctx) {
      ctx.save();
      let r = this.width / 2;
      let size = (0.4 * r) / 2;
      // 绘制箭头
      let img = new Image();
      img.src = down_img;
      ctx.drawImage(img, r - (this.width === 60 ? 20 : 18), r - 5);
      // 绘制文字
      ctx.font = `${this.width === 60 ? 10 : 9}px 微软雅黑`;
      ctx.fillStyle = this.textColor;
      // ctx.textAlign = "center";
      ctx.fillText(`${this.circleText}`, r - 12, r + size / 2);
      ctx.restore();
    },
    setWidth: function() {
      let docEl = document.documentElement;
      this.width = docEl.clientWidth > 1440 ? 60 : 45;
      this.height = docEl.clientWidth > 1440 ? 60 : 45;
    }
  },
  mounted() {
    this.setWidth();
    this.ele = document.getElementById(`progress-wave-${this.unique}`);
    this.draw();
  }
};
</script>

<style scoped lang="less">
</style>